import React from "react";

export default function HomeButton() {
    return <svg data-name="home-btn">
        <path className="home-btn-16" d="M0,5.51,22.51,87.63a1,1,0,0,0,1.26.66L95.29,66.06a1,1,0,0,0,.7-1.13L86.48.84a1,1,0,0,0-1-.84L1,4.21A1,1,0,0,0,0,5.51Z"/>
        <path className="home-btn-19" d="M74.81,47.46,58.14,25.33c-2.84-3.77-7.49-3.77-10.33,0L31.15,47.46c-2.84,3.77-1.31,6.85,3.41,6.85h2V66a6.45,6.45,0,0,0,12.9,0V56.91h7V66a6.45,6.45,0,1,0,12.9,0V54.31H71.4C76.11,54.31,77.65,51.23,74.81,47.46Z"/>
        <path className="home-btn-2" d="M74.12,38.41,57.45,16.27c-2.84-3.77-7.49-3.77-10.33,0L30.46,38.41c-2.84,3.76-1.31,6.85,3.41,6.85h2V57a6.45,6.45,0,1,0,12.9,0V47.85h6.95V57a6.45,6.45,0,1,0,12.9,0V45.26h2C75.42,45.26,77,42.17,74.12,38.41Z"/>
    </svg>;
}
